import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'

import DueDateComponent from '../DueDateComponent'
import ColourIndicator from '../../../Settings/Controls/Edit/ColourIndicator'
import SubtaskTitle from '../SubtaskTitle'

import { fetchStatus } from '../../../../slices/taskStatus'
import useStyles from './styles'

type SubtaskMobileDefaultProps = {
  task: APITask
  taskClick?: CallableFunction
}

const SubtaskMobileDefault: React.FC<SubtaskMobileDefaultProps> = ({
  task,
  taskClick
}) => {
  const dispatch = useAppDispatch()
  const taskStatus = useAppSelector(storeState => storeState.taskStatus)
  const { statuses } = taskStatus

  const classes = useStyles()

  const colour =
    statuses.find(({ id }) => id === task.status_id)?.colour ?? null

  React.useEffect(() => {
    if (!taskStatus.loaded && !taskStatus.loading) {
      dispatch(fetchStatus())
    }
  }, [taskStatus, dispatch])

  return (
    <div className={classes.root}>
      <div style={{ flexBasis: '25%', textAlign: 'center', flexShrink: 0 }}>
        <DueDateComponent task={task} mobile />
      </div>

      <div className={classes.color}>
        {/* @ts-ignore */}
        <ColourIndicator colour={colour} />
      </div>

      <div style={{ flexBasis: '75%' }}>
        <SubtaskTitle task={task} mobile taskClick={taskClick} />
      </div>
    </div>
  )
}

export default React.memo(SubtaskMobileDefault)
